export const CREATE_ORDER_TYPE_SELECT_LABEL_ID =
  'create-order-type-select-label-id';
export const CREATE_ORDER_TYPE_SELECT_ID = 'create-order-type-select-id';
export const CREATE_ORDER_PURCHASER_SELECT_LABEL_ID =
  'create-order-purchaser-label-id';
export const CREATE_ORDER_PURCHASER_SELECT_ID = 'create-order-purchaser-id';
